import { render, staticRenderFns } from "./CampaignInitialSettings.vue?vue&type=template&id=f3f534c6&scoped=true&"
import script from "./CampaignInitialSettings.vue?vue&type=script&lang=ts&"
export * from "./CampaignInitialSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignInitialSettings.vue?vue&type=style&index=0&id=f3f534c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f534c6",
  null
  
)

export default component.exports